<div class="return-order-container">
	@if (!isSuccess) {
		<div class="alert alert-danger" role="alert">
			<h4 class="alert-heading">{{ appData().jobsites.errorReturnOrderHeader }}</h4>
			<p>{{ appData().jobsites.errorReturnOrderBody }}</p>
		</div>
	}

	@if (sendingRequest) {
		<cramo-loading-area [title]="appData().jobsites.sendingTransportRequestMessage" [showTransparent]="true" />
	} @else {
		<div class="order-return-row__container">
			<div class="order-return-row__header d-none d-md-block">
				<div class="row">
					<div class="col-3 text-center">{{ appData().global.product }}</div>
					<div class="col-9">
						<div class="row">
							<div class="col-md-7"></div>
							<div class="col-md-5 text-center">{{ appData().global.quantity }}</div>
						</div>
					</div>
				</div>
				<hr />
			</div>
			@for (selectedOrder of ordersToReturn; track selectedOrder.OrderId) {
				<div class="order-return-row">
					<div class="row">
						<div class="col-3 text-center">
							<img
								[class.no-image]="!orderImages[selectedOrder.OrderId].hasImage"
								[src]="orderImages[selectedOrder.OrderId].imageUrl"
								alt="Product image"
							/>
							<div class="product-number">{{ selectedOrder.OrderRow.ItemId }}</div>
						</div>
						<div class="col-9 d-flex justify-content-center flex-column">
							<div class="row">
								<div class="col-md-7">
									<div class="product-name">{{ selectedOrder.OrderRow.ProductName }}</div>
									<div class="order-number">
										{{ appData().jobsites.orderItemOrderNumberHeadlineText }}: {{ selectedOrder.OrderRow.OrderId }}
									</div>
								</div>
								<div class="col-md-5 text-md-center mt-2 mt-md-0">
									<cramo-stepper-old
										[stepperOptions]="selectedOrder.stepperOptions"
										(byValueChange)="changeOrderQuantityValue(selectedOrder, $event)"
										[disabled]="selectedOrder.OrderRow.Quantity === 1"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			}
		</div>
		<div class="pickup-container">
			<div class="row">
				<div class="col-md-6">
					<div class="label">{{ appData().global.transportFrom }}</div>
					<div>{{ jobsiteAddress.StreetAddress }}</div>
					<div>{{ jobsiteAddress.Zip }} {{ jobsiteAddress.City }}</div>
					@if (featureToggles().price.isReturnTransportPricingEnabled) {
						@if (featureToggles().price.isReturnTransportPriceWaiverTextEnabled) {
							<div class="return-transport-waiver-text">
								<cramo-icon iconName="info" iconDisplay="inline" />
								{{ appData().jobsites.returnTransportPriceWaiverText }}
							</div>
						}
						@if (!isloadingTransportPricing) {
							@if (transportCostErrorMessage !== null) {
								<div class="tranport-cost-calculation-failed-text">
									<cramo-icon iconName="info" iconDisplay="inline" />
									{{ transportCostErrorMessage }}
								</div>
							} @else {
								<div class="price-list">
									<div class="price-list-item">
										<label>{{ appData().cartPage.transportCostLabel }}</label>
										<cramo-price-display [price]="transportCostResult.price" />
									</div>
									<div class="price-list-item">
										<label>{{ appData().cartPage.transportVatLabel }} {{ transportCostResult.vatPercentage }}%</label>
										<cramo-price-display [price]="transportCostResult.vat" />
									</div>
								</div>
							}
						} @else {
							{{ appData().checkout.loadingTransportPrice }}
						}
					}

					<div class="transport-instructions-container">
						<mat-slide-toggle
							color="primary"
							[(ngModel)]="showTransportInstructions"
							labelposition="after"
							disableRipple="true"
						>
							{{ appData().jobsites.additionalInstructions }}
						</mat-slide-toggle>
						@if (showTransportInstructions) {
							<div class="transport-instructions">
								<div class="form-group">
									<label for="transportInstructions"> {{ appData().jobsites.transportInstruction }} </label>
									<textarea
										id="transportInstructions"
										class="form-control"
										[placeholder]="appData().jobsites.transportInstructionTxtPlaceholder"
										[(ngModel)]="transportInstructions"
									></textarea>
								</div>
							</div>
						}
					</div>
				</div>
				<div class="col-md-6">
					<div class="label">{{ appData().global.returnDate }}</div>
					<cramo-calendar
						[calendarOptions]="calendarOptions"
						[disabled]="disableReturnDateSelection"
						[alignLeft]="true"
						(byDateChange)="onReturnDateChange()"
					/>
				</div>
			</div>
		</div>
	}
</div>
